import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasThhHundData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasThhHundDataForShop } from './transformer/thhHundData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasThhHundData
>(App.THH_HUND);
export const shopTarifierer = new ShopTarifierer({
  appId: App.THH_HUND,
  taasDataBuilder: buildTaasThhHundDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungThhHund(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_HUND,
    safeSaga(shopTarifierer.handleSuccess, App.THH_HUND),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.THH_HUND),
  );
}
